__turbopack_context__.v({
  "icon": "q1XXqa_icon",
  "input": "q1XXqa_input",
  "placeholder": "q1XXqa_placeholder",
});
